// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---YOrOr","sk-bouncedelay":"sk-bouncedelay---Nn4wS","bounce1":"bounce1---NIjug","bounce2":"bounce2---tPwEf"};